import React, { useCallback, useMemo } from "react";
// import "../Home.sass";
// import semver from "semver";
import Diagnostics from "./components/Diagnostics";
// import CheckUpdates from "./components/CheckUpdates";
// import Provisioning from "./components/Provisioning";
import WampConnect from "../components/WampConnect";
import loader from "svg-loaders/svg-css-loaders/three-dots.svg";
// import EnableAutoUpdate from "./components/EnableAutoUpdate";

const states = {
    CHECKSESSION: 1,
    FETCHDIAGNOSTICS: 2,
};

const Home = ({ match }) => {

    const printState = (state) => {
        const foundKey = Object.keys(states).find((k) => {
            return states[k] === state;
        });
        return foundKey;
    }

    const [session, setSession] = React.useState();
    const [viewComponent, setViewComponent] = React.useState();
    const [installedPackages, setInstalledPackages] = React.useState();
    const [viewState, setViewState] = React.useState(states.CHECKSESSION);

    const transitionTo = (newState) => {
        console.log(`Home: going from state  ${printState(viewState)} to ${printState(newState)}`);
        if (viewState === newState) {
            console.log(`from and to state are the same`);
            return;
        }
        switch (newState) {
            case states.FETCHDIAGNOSTICS:
                if (viewState === states.CHECKSESSION)
                    setViewState(states.FETCHDIAGNOSTICS);
                break;
            // case states.CHECKUPDATES:
            //     if (viewState === states.CHECKINTERNET)
            //         setViewState(states.CHECKUPDATES);
            //     break;
            // case states.PROVISIONING:
            //     if (viewState === states.CHECKUPDATES)
            //         setViewState(states.PROVISIONING);
            //     break;
            // case states.ENABLEAUTOUPDATES:
            //     if (viewState === states.PROVISIONING)
            //         setViewState(states.ENABLEAUTOUPDATES);
            //     break;
            // case states.FINISHED:
            //     if (viewState === states.ENABLEAUTOUPDATES)
            //         setViewState(states.FINISHED);
            //     break;
            default:
                console.log("unknown target state");
        }
    };

    // React.useEffect(() => {
    //     console.log("boot");
    // });

    React.useEffect(() => {
        // const footer = () => {
        console.log(`Home: in state  ${printState(viewState)}`);
        switch (viewState) {
            case states.CHECKSESSION:
                break;

            case states.FETCHDIAGNOSTICS:
                setViewComponent(
                    <>
                        <Diagnostics
                            session={session}
                            onSuccess={() => {
                            }
                            } />
                    </>
                );
                break;
            // case states.CHECKUPDATES:
            //     setViewComponent(
            //         <>
            //             <div className="is-5 has-text-info">Checking for updates</div>
            //             <CheckUpdates
            //                 session={session}
            //                 onPackages={(packages) => { setInstalledPackages(packages) }}
            //                 onSuccess={() => {
            //                     console.log("home:success Checkupdates")
            //                     transitionTo(states.PROVISIONING);
            //                 }} />
            //         </>
            //     )
            //     break;
            // case states.PROVISIONING:
            //     // if (match.params && match.params.provisioningprofile) {
            //     setViewComponent(
            //         <>
            //             <div className="is-5 has-text-info">Provisioning your AVADO</div>
            //             <Provisioning
            //                 session={session}
            //                 provisioningprofile={match.params.provisioningprofile}
            //                 onSuccess={() => {
            //                     console.log(`prov done`)
            //                     transitionTo(states.ENABLEAUTOUPDATES);
            //                 }} />
            //         </>
            //     );
            //     // transitionTo(states.FINISHED);
            //     // } else {
            //     //     console.log(`No provisioning profile found`);
            //     //     transitionTo(states.ENABLEAUTOUPDATES);
            //     // }
            //     break;
            // case states.ENABLEAUTOUPDATES:
            //     setViewComponent(
            //         <>
            //             <div className="is-5 has-text-info">Checking for updates</div>
            //             <EnableAutoUpdate
            //                 session={session}
            //                 onSuccess={() => {
            //                     console.log("home:success EnableAutoupdates")
            //                     transitionTo(states.FINISHED);
            //                 }} />
            //         </>
            //     )
            //     break;
            // case states.FINISHED:

            //     const dappMgr = installedPackages && installedPackages.find((p) => { return p.name === "dappmanager.dnp.dappnode.eth" });

            //     console.log(dappMgr.version);

            //     let targetUrl = "http://my.avado";

            //     if (semver.gt(dappMgr.version, "10.0.22")) {
            //         targetUrl = "http://my.ava.do/"
            //     }

            //     setViewComponent(
            //         <>
            //             <div className="is-5 has-text-info">You're all set up!</div><br />
            //             <a href={targetUrl} className="button is-outline">Go to my AVADO</a>
            //         </>
            //     );
            //     break;
            default:
                console.log(`we should not drop down in here`)
                break;
        }

    }, [viewState]);

    // const f = footer();


    if (!session) {
        return (
            <>
                <WampConnect onConnect={(session) => {
                    setSession(session);
                    transitionTo(states.FETCHDIAGNOSTICS);
                }} />
                <section className="section hero is-fullheight has-avado-bg">
                    <div className="hero-body is-vcentered">
                        <div className="container has-text-left has-text-white">
                            <div className="has-text-centered  is-size-4">
                                <h3 className="title is-3">Connecting to your AVADO</h3>
                                <div><span className="icon"><img alt="loader" src={loader} /></span></div>
                                <br />
                                <p >
                                    Please connect to AVADO's WiFi <br />(SSID=<b>AVADO</b> /
                                    password=<b>avado123</b>)<br /><br />
                                </p>
                                <p className="title is-6">This page will automatically load again when you are connected.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }

    return (
        <div>
            <section className="section hero is-fullheight has-avado-bg">
                <div className="hero-body is-vcentered">
                    <div className="container has-text-left has-text-white">
                        <h1 className="title is-1">Troubleshooting buttons</h1>
                        {/* <h2 className="title is-2">SNAP! Let's check what's wrong.</h2> */}
                        {/* <div className="hero-padding" /> */}
                        {viewComponent}
                    </div>
                </div>
            </section>
        </div >
    );

}

export default Home;
